import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: 'Work Sans', sans-serif;
  }

  html {
    overflow-x: hidden;
    overflow-y: scroll;
    -ms-overflow-style: scrollbar;
    min-height: 100vh;
  }

  body {
    margin: 0;
    padding: 0;
    min-height: 100vh;
    display: flex;
    -webkit-font-smoothing: antialiased;
  }

  body > #root {
    font-family: 'Work Sans', sans-serif;
    font-size: 16px;
    background-color: #ffffff;
    flex-grow: 1;
    display: flex;

    > div:first-child {
      flex-grow: 1;
    }
  }

  a:visited,
  a:link,
  a:hover,
  a:active {
    text-decoration: none;
    font-weight: bold;
    color: inherit;
  }

  button {
    outline: none;
    border: none;
    background: none;
    margin: 0;
    padding: 0;
  }

  pre {
    margin: 0;
    font-family: 'Work Sans', sans-serif;
  }
`;
